'use strict';

import Constants from '../../../checkout/constants.js';
import ObjectAssign from 'object-assign';
import ParseValidation from '../../../../../helpers/parse-validation';

const steps = { 'ORGANIZATION_DETAILS': 1, 'PAYMENT_DETAILS': 2 };

const initialState = {
    step: steps.ORGANIZATION_DETAILS,
    show: false,
    loading: false,
    error: undefined,
    hasError: {},
    help: {},
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: '',
    zip: ''
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.GOTO_PAYMENT_DETAILS) {
        const data = action.data;
        if ( !data.name) {
            return ObjectAssign({}, state, {
                error: 'Name is required.',
                hasError: { name: true }
            });
        }

        return ObjectAssign({}, state, {
            hasError: {},
            error: undefined,
            step: steps.PAYMENT_DETAILS,
            name: data.name,
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            state: data.state,
            country: data.country,
            zip: data.zip,
            phone: data.phone
        });
    }

    if (action.type === Constants.GOTO_ORGANIZATION_DETAILS) {
        return ObjectAssign({}, state, {
            step: steps.ORGANIZATION_DETAILS
        });
    }

    if (action.type === Constants.CREATE_NEW) {
        return ObjectAssign({}, state, {
            loading: true,
            name: action.request.data.name,
            description: action.request.data.description,
            organization_id: action.request.organization_id
        });
    }

    if (action.type === Constants.CREATE_NEW_RESPONSE) {
        const validation = ParseValidation(action.response);
        const stateUpdates = {
            loading: false,
            error: validation.error,
            hasError: validation.hasError,
            help: validation.help
        };

        if (!validation.error) {
            stateUpdates.name = '';
            stateUpdates.address1 = '';
            stateUpdates.address2 = '';
            stateUpdates.city = '';
            stateUpdates.state = '';
            stateUpdates.country = '';
            stateUpdates.zip = '';
        }

        return ObjectAssign({}, state, stateUpdates);
    }

    if (action.type === Constants.SHOW_CREATE_NEW) {
        return ObjectAssign({}, state, {
            show: true
        });
    }

    if (action.type === Constants.HIDE_CREATE_NEW) {
        return ObjectAssign({}, state, {
            show: false
        });
    }

    return state;
};

reducer.Steps = steps;

export { steps as Steps };
export default reducer;
